import * as React from 'react'
import { useMemo } from 'react'

import { ClosedDecoration } from '../../../EntityCards/ClosedDecoration'
import { HeaderContainer } from '@user/components/DetailPages/HeaderContainer'
import type { ILeadDetail } from '@user/store/lead/typings'
import { LEAD_STATUSES } from '../../LeadCard/typings'

interface Props {
  detail: ILeadDetail
  status: LEAD_STATUSES
}

export function ClosedDecorationHeader(props: Props) {
  const { detail, status } = props

  const isDisqualified = useMemo(() => {
    return !!status && status == LEAD_STATUSES.Disqualified
  }, [status])

  return (
    <>
      {!!isDisqualified && (
        <HeaderContainer color="#ffecec" hideBorder paddingY="8px">
          <ClosedDecoration
            date={detail.closedDate}
            reason={detail.customDisqualifiedReason}
            status={status}
          />
        </HeaderContainer>
      )}
    </>
  )
}
